import React, {useRef, useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {AsideMenuMain} from './AsideMenuMain'
import {DrawerComponent, ScrollComponent, ToggleComponent} from '../../../assets/ts/components'
import {isZadRoute} from '../../../../workspace'

type Props = {
  asideMenuCSSClasses: string[]
}

const asideMenuScrollByWorkspace: Record<string, number> = {}

function workspaceKeyFromPath(pathname: string): 'zad' | 'maarefati' {
  return isZadRoute(pathname) ? 'zad' : 'maarefati'
}

const AsideMenu: React.FC<Props> = ({asideMenuCSSClasses}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const {pathname} = useLocation()
  const lastWorkspace = useRef(workspaceKeyFromPath(pathname))

  useEffect(() => {
    const workspaceKey = workspaceKeyFromPath(pathname)
    const wrapper = scrollRef.current
    if (wrapper) {
      asideMenuScrollByWorkspace[lastWorkspace.current] = wrapper.scrollTop
    }
    lastWorkspace.current = workspaceKey

    const restoreAsideScroll = () => {
      if (!scrollRef.current) return
      scrollRef.current.scrollTop = asideMenuScrollByWorkspace[workspaceKey] ?? 0
    }

    const pluginsTimer = window.setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      restoreAsideScroll()
    }, 50)
    // MasterLayout reinitializes MenuComponent at 500ms and would otherwise jump the sidebar.
    const restoreTimer = window.setTimeout(restoreAsideScroll, 560)

    return () => {
      window.clearTimeout(pluginsTimer)
      window.clearTimeout(restoreTimer)
    }
  }, [pathname])

  return (
    <div
      id='kt_aside_menu_wrapper'
      ref={scrollRef}
      className='hover-scroll-overlay-y my-5 my-lg-5'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer'
      data-kt-scroll-wrappers='#kt_aside_menu'
      data-kt-scroll-offset='0'
    >
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className={clsx(
          'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
          asideMenuCSSClasses.join(' ')
        )}
      >
        <AsideMenuMain />
      </div>
    </div>
  )
}

export {AsideMenu}
